import { IS_PUBLIC, NO_AUTH_NEEDED } from '@/types';

const DocumentAccessPage = () => import('@/document-access/pages/document-access.vue');

export const documentAccessRoutes = [
  {
    path: '/document/access/:token',
    name: 'document-access',
    component: DocumentAccessPage,
    meta: {
      [NO_AUTH_NEEDED]: true,
      [IS_PUBLIC]: true,
      layout: 'layout-empty',
    },
  },
];
